import { Injectable } from "@angular/core";
import { from, Observable, of, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { addGeofenceRequestDTO } from "../models/addGeofences/addGeofenceRequestDTO";
import { geofenceDTO } from "../models/geofenceDTO";
import { addGeofencesRequestDTO } from "../models/addGeofences/addGeofencesRequestDTO";
import { GeofencesAPIService } from "../../shared/services/API/GeofencesAPI.service";

@Injectable({
  providedIn: "root",
})
export class GeofencesService {
 
  getAllGeofencesGeoJson_Subscription: Subscription;
  getFencesCentroidsGeoJson_Subscription: Subscription;
  
   isVisiblePanelGeofences$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelAddGeofences$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelEditGeofences$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelDetailGeofences$: Subject<boolean>= new Subject<boolean>();

   private isLoading$: Subject<boolean> = new Subject();

  DataGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();
  DataCentrroidGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();
  geofenceSelected$: Subject<geofenceDTO> = new Subject<geofenceDTO>();

  public Result;

  constructor(private geofence: GeofencesAPIService) {
  }

  setVisiblePanelGeofences(resp){
    this.isVisiblePanelGeofences$.next(resp);
  }

  getVisiblePanelGeofences(): Observable<boolean> {
    return this.isVisiblePanelGeofences$.asObservable();
  }

  setVisiblePanelEditGeofences(resp){
    this.isVisiblePanelEditGeofences$.next(resp);
  }

  setVisiblePanelDetailGeofences(resp){
    this.isVisiblePanelDetailGeofences$.next(resp);
  }

  getVisiblePanelDetailGeofences(): Observable<boolean> {
    return this.isVisiblePanelDetailGeofences$.asObservable();
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  getVisiblePanelEditGeofences(): Observable<boolean> {
    return this.isVisiblePanelEditGeofences$.asObservable();
  }

  FullDelete(Guid: string) : any {
    return this.geofence.FullDelete(Guid);
  }

  delete(Guid: string): any {
    return this.geofence.delete(Guid);
  }

  Deactivate(Guid: string): any {
    return this.geofence.Deactivate(Guid);
  }

  deleteGeofence($Guid: string) : any {
    return this.geofence.deleteGeofence($Guid);
  }

  getAllGeofencesGeoJson(): any {
    this.getAllGeofencesGeoJson_Subscription = this.geofence.getAllGeofencesGeoJson().subscribe((data) => {
        this.DataGeoJson$.next(data);
        this.getAllGeofencesGeoJson_Subscription.unsubscribe();
      });
    return this.DataGeoJson$.asObservable();
  }

  GetFencesCentroidsGeoJson(): any {
    this.getFencesCentroidsGeoJson_Subscription = this.geofence.GetFencesCentroidsGeoJson().subscribe((data) => {
        this.DataCentrroidGeoJson$.next(data);
        this.getFencesCentroidsGeoJson_Subscription.unsubscribe();
      });
    return this.DataCentrroidGeoJson$.asObservable();
  }

  get(guid): any {
    return this.geofence.get(guid);
  }

  GetByName(name): any {
    return this.geofence.GetByName(name);
  }

  Insert(request: addGeofenceRequestDTO): any {
    return this.geofence.Insert(request);
  }

  InsertV2(request: addGeofencesRequestDTO): any {
    return this.geofence.InsertV2(request);
  }

  UnassignIdentifier(guid, identifier): any {
    return this.geofence.UnassignIdentifier(guid, identifier);
  }
  
  findByIdentifier(identifier): any {
    return this.geofence.findByIdentifier(identifier);
  }

  getList(): any {
    return this.geofence.getList();
  }

  getStates(){
    return this.geofence.getStates();
  }

  getMunicipalities(stateId: string){
    return this.geofence.getMunicipalities(stateId);
  }
}
